import * as app from './modules/app'
import * as account from './modules/account'
import * as users from './modules/users'
import * as notifications from './modules/notifications'
import * as assistant from './modules/assistant'

const reducers = {
  ...app.reducers,
  ...account.reducers,
  ...users.reducers,
  ...notifications.reducers,
  ...assistant.reducers,
}

export default reducers
